import { render, staticRenderFns } from "./UpdateInformation.vue?vue&type=template&id=73ffaf5a"
import script from "./UpdateInformation.vue?vue&type=script&lang=js"
export * from "./UpdateInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports